import { firstValueFrom } from 'rxjs';

import { UserService } from '../services/user.service';
import { User } from '../../../models/user.model';

export function fetchUser(userService: UserService) {
  return async (): Promise<User | undefined> => {
    // Only try to fetch user if we have a token
    if (!userService.hasToken()) {
      return undefined;
    }

    try {
      const userPromise = firstValueFrom(userService.fetchUser());
      return await userPromise;
    } catch {
      // If fetch fails, the token is probably invalid
      // UserService.fetchUser already handles cleanup in its catchError
      console.log('Failed to fetch user during app initialization, token may be invalid');
      return undefined;
    }
  };
}
